import { createContext, useContext, useEffect, useState, type ReactNode } from 'react';
import { logError } from 'utils/error';

const GeoContext = createContext<string | undefined>(undefined);

export const useGeo = () => useContext(GeoContext);

const getStoredCountryCode = (): string | undefined => {
  try {
    return sessionStorage.getItem('userCountryCode') ?? undefined;
  } catch {
    return undefined;
  }
};

const setStoredCountryCode = (code: string): void => {
  try {
    sessionStorage.setItem('userCountryCode', code);
  } catch {
    console.error('Storage not available in this environment');
    logError('Storage not available in this environment');
  }
};

export const GeoContextProvider = ({ children }: { children: ReactNode }) => {
  const [userCountryCode, setUserCountryCode] = useState<string | undefined>(getStoredCountryCode);

  useEffect(() => {
    if (userCountryCode) return;

    fetch('https://geoip.prod.rtl.de/ip')
      .then((res) => res.json())
      .then((data) => {
        const countryCode = data.country.toLowerCase();
        setUserCountryCode(countryCode);
        setStoredCountryCode(countryCode);
      })
      .catch((error) => {
        console.error('GeoIP Api fetch error:', error);
        logError(`GeoIP Api fetch error`, { error: error });
        setUserCountryCode('de');
      });
  }, [userCountryCode]);

  return <GeoContext.Provider value={userCountryCode}>{children}</GeoContext.Provider>;
};
